var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ImageUploader',{attrs:{"title":`${_vm.genericFormItemData.name}${_vm.genericFormItemData.required ? ' (Required) ' : ''}`,"desc":_vm.genericFormItemData.description,"widthOptionEnabled":false,"hasSmallSpacing":true,"mediaLibraryID":_vm.input},on:{"update":_vm.selectImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }